import UnStyledLink from '@/agilis/components/UnstyledLink/UnstyledLink.vue'
import Configuration from '@/agilis/util/Configuration'
import ChartjsPie from '@/agilis/components/Chart/Chartjs/ChartjsPie/ChartjsPie.vue'
import ChartjsLine from '@/agilis/components/Chart/Chartjs/ChartjsLine/ChartjsLine.vue'
import EchartsPie from '@/agilis/components/Chart/Echarts/EchartsPie/EchartsPie.vue'
import EchartsLine from '@/agilis/components/Chart/Echarts/EchartsLine/EchartsLine.vue'
import MetricTitle from '../MetricTitle/MetricTitle.vue'

export default {
  name: 'DashboardChart',
  components: { EchartsLine, EchartsPie, UnStyledLink, ChartjsPie, ChartjsLine, MetricTitle },
  props: {
    metric: Object,
    items: Array,
    loading: [Boolean, String],
    context: Object
  },
  data () {
    return {
      detailsModal: false,
      loadingDetail: false
    }
  },

  computed: {
    detailHeaders () {
      return Configuration.datatable.getHeaders(this.metric.detail.dataTable)
    }
  },
  methods: {
    renderColumn (colId, item) {
      const colConfig = this.metric.detail.dataTable.columns[colId]
      return Configuration.datatable.renderColumn(colConfig, item)
    }
  }
}
